__webpack_require__.p = "/react-boilerplate-2022-github-pages/";